import { useApplicantAPI } from "@certn/api";

import { useUser } from "./useUser";

export function useLanguageOptions() {
  const { details: userDetails } = useUser();
  const { data: languageOptions, isLoading } = useApplicantAPI(
    userDetails
      ? "/api/internal/applicant/me/preferences/language-options/"
      : null
  );

  return {
    languageOptions,
    isLoading,
  };
}
